<template>
    <div class="row">
        <!-- main title -->
        <div class="col-12">
            <div class="main__title">
                <h2>افزودن ویدئو کاربر</h2>
            </div>
        </div>
        <!-- end main title -->

        <!-- form -->
        <div class="col-12">
            <div class="form">
                <div class="row">


                    <div class="col-12 col-md-7 form__content">
                        <div class="row">
                          <div class="col-12">
                            <treeselect
                                :async="true"
                                @select="user_id"
                                :load-options="search_users"
                                placeholder="جستجو کاربر"
                                :normalizer="normalizer_users"
                            />
                          </div>
                          <div class="col-12">
                            <treeselect
                                :async="true"
                                @select="select_url"
                                :load-options="load_uploader"
                                placeholder="جستجو لینک"
                                :normalizer="normalizer_uploader"
                            />
                          </div>

                            <div class="col-12">
                                <div class="form__group">
                                    <input v-model="link" type="text" class="form__input" placeholder="لینک">
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form__group">
                                    <input v-model="name" type="text" class="form__input" placeholder="نام ویدئو">
                                </div>
                            </div>


                        </div>
                    </div>


                    <div class="col-12">
                        <div class="row">

                            <div class="col-12">
                                <button type="button" class="form__btn" @click="insert_data2">{{status_form ==0 ?
                                    'افزودن' : 'ویرایش'}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- end form -->
    </div>
</template>

<script>
    import axios from "axios";
    // import {bus} from '../main';
    import Datatable from "@/views/customTable/Datatable";
    import Treeselect, {ASYNC_SEARCH} from "vue3-treeselect";
    import 'vue3-treeselect/dist/vue3-treeselect.css'
    // import the styles
    const simulateAsyncOperation = fn => {
      setTimeout(fn, 200)
    }
    export default {
        name: 'HelloWorld',
        data() {
            return {
                items: [],
                fields: [
                    {key: 'row', label: 'ردیف'},
                    {key: 'link', label: 'لینک'},
                    {key: 'operation', label: 'عملیات'}
                ],
                status_form: 0,
                name: '',
              user_id:51760,

                link: '',
              load_uploader({action, searchQuery, callback}) {

                if (action === ASYNC_SEARCH) {
                  simulateAsyncOperation(() => {
                    let options;
                    axios.post('search_upload_video', {
                      search: searchQuery,

                    }).then(function (response) {
                      options = response.data;
                      callback(null, options);
                      // localStorage.setItem("api_token", response.data.access_token);
                      // self.$router.push({ path: 'notes' });
                    })
                        .catch(function (error) {

                          console.log(error);
                        });


                    //  const options = this.get_keywords(searchQuery);
                    // const options = [1, 2, 3, 4, 5].map(i => ({
                    //     id: `${searchQuery}-${i}`,
                    //     name: `${searchQuery}-${i}`,
                    // }))

                  })
                }
              },
              normalizer_uploader(node) {
                return {
                  id: node.id,
                  label: node.title,
                }
              },


              search_users({action, searchQuery, callback}) {

                if (action === ASYNC_SEARCH) {
                  simulateAsyncOperation(() => {
                    let options;
                    axios.post('search_user', {
                      txt: searchQuery,

                    }).then(function (response) {
                      options = response.data;
                      callback(null, options);
                      // localStorage.setItem("api_token", response.data.access_token);
                      // self.$router.push({ path: 'notes' });
                    })
                        .catch(function (error) {

                          console.log(error);
                        });


                    //  const options = this.get_keywords(searchQuery);
                    // const options = [1, 2, 3, 4, 5].map(i => ({
                    //     id: `${searchQuery}-${i}`,
                    //     name: `${searchQuery}-${i}`,
                    // }))

                  })
                }
              },
              normalizer_users(node) {
                return {
                  id: node.id,
                  label: node.name,
                }
              },
            }
        },
        components: {
            Datatable,
          Treeselect
        },
        mounted() {

        },
        methods: {
          select_url(node ,id){
            this.link = node.url
            this.name = node.title
          },
            edit_item(item) {
                this.link = item.link;
                this.status_form = item.id;
            },
            insert_data2() {

                var self = this;
                if (this.name == "") {
                    return
                }
                var formData = new FormData();
                var url = 'add_user_video'
                formData.append('link', this.link);
                formData.append('user_id', this.user_id);
                formData.append('name', this.name);

                this.axios.post(url, formData, {}).then(function (response) {
if(response.data.error==0){
  self.link = ''
  self.status_form = 0;
  self.$toast.success('ثبت با موفقیت انجام شد');

}else{
  self.$toast.error('خطا در ثبت');

}

                }).catch(function (error) {
                    console.log(error);
                    self.$toast.error('خطا در ثبت اطلاعات');

                });


            },
        }
    }
</script>

